import { computed } from 'vue'

import { useQuery } from '@/composables/api'
import { useOverpayments } from '@/composables/useOverpayments'
import useAuthStore from '@/stores/authStore'

/**
 * The two navigation counts, unread tickets and actionable overpayments, as TanStack queries: the
 * ticket mutations and the refund flow refresh them through query invalidation, no event bus needed.
 */
export function useNavigationBadges() {
  const authStore = useAuthStore()

  // Only the count is needed: max_results 1 keeps the payload to one row + _meta.total.
  const unreadTicketsQuery = useQuery('/tickets', {
    query: { where: { read_by_requester: false }, max_results: 1 },
  })
  const unreadTickets = computed(() => unreadTicketsQuery.data.value?._meta?.total ?? 0)

  // Same source as the Overpayments view, so the badge and the list can never disagree. A company
  // session without a signatory cannot act on any record, so its badge shows nothing to do.
  const { unhandledCount } = useOverpayments()
  const unhandledOverpayments = computed(() => (authStore.isCompanyWithoutSignatory ? 0 : unhandledCount.value))

  // The collapsed burger icon carries everything waiting inside the drawer.
  const total = computed(() => unreadTickets.value + unhandledOverpayments.value)

  return { unreadTickets, unhandledOverpayments, total }
}
